if (!(window as any).uniqueId) {
	let counter = 0;
	(window as any).uniqueId = function() {
		return 'WUID' + counter++
	}
}


export default function wuid() {
	return (window as any).uniqueId();
}
